import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'
import { Content, GridContainer, GridItem } from './HomeMechanisms.styles'

/**
 * The HomeMechanisms's container.
 */
const HomeMechanisms = () => {
  const { size } = useViewport()

  return (
    <Content>
      <GridContainer>
        <GridItem xs={12} md={6}>
          <Typography
            color="primary"
            fontSize="18px"
            fontWeight="bold"
            lineHeight="21px"
            margin={size.isUpToMedium ? '96px 0 0' : '24px 0'}
            variant="body1"
          >
            Procesos de compra
          </Typography>
          <Typography
            fontSize="34px"
            fontWeight="bold"
            lineHeight="38px"
            margin={size.isUpToMedium ? '12px 0' : '0'}
            variant="h2"
            width={size.isUpToMedium ? '485px' : undefined}
          >
            Mecanismos utilizados por el Estado de Chile
          </Typography>
          <Typography
            fontSize="18px"
            lineHeight="24px"
            margin={size.isUpToMedium ? '0 0 48px' : '24px 0'}
            variant="body1"
            width={size.isUpToMedium ? '448px' : undefined}
          >
            Revisa el monto transado y número de órdenes de compra asociadas a cada mecanismo utilizado en las
            transacciones realizadas en Mercado Público.
          </Typography>
        </GridItem>
      </GridContainer>
    </Content>
  )
}

export default HomeMechanisms
